import { CUSTOMER_SEARCH_INPUT_OPTIONS } from '~services/constant/customer';
import HelperOptions from '~component/helper/helper-options';

// 搜索客户的主输入框，对应的字段类型
export default {
  functional: true,
  render(createElement, context) {
    const { data } = context;

    return (
      <HelperOptions
        { ...data }
        options={ CUSTOMER_SEARCH_INPUT_OPTIONS }
      />
    );
  },
};
